import { maxDocumentUploadSize } from '@black-bear-energy/black-bear-energy-common'

export const maxDocumentUploadSizeMB = Math.round(
  maxDocumentUploadSize / (1024 * 1024)
)

export function exceedsMaxUploadSize(files: File[]): boolean {
  const totalSize = files.reduce((sum, file) => sum + file.size, 0)
  return totalSize > maxDocumentUploadSize
}

export function fileComponents(name: string) {
  const dotIndex = name.search(/\./g)
  return {
    filename: name.substr(0, dotIndex),
    extension: name.substr(dotIndex),
  }
}

export const appendedFilename = (name = '', appendToFilename = '') => {
  const date = new Date()
  const { filename, extension } = fileComponents(name)
  const appendedFileName = `${date.getTime()}-${filename}${
    appendToFilename ? `-${appendToFilename}` : ''
  }`
  return `${appendedFileName}${extension ? `.${extension}` : ''}`
}
